import { render, staticRenderFns } from "./PictureInfo.vue?vue&type=template&id=6db153aa&"
import script from "./PictureInfo.vue?vue&type=script&lang=js&"
export * from "./PictureInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports